import React from 'react';

const InfoImage = (props) => {
  return (
    <div className="infoImage">
      <div className="infoImage-contents" style = {props.obj.style}>
        <div className={`infoImage-dim ${props.obj.color}`} ></div>

        <p className="script">
        {
          props.obj.text.split('\n').map( (line, index) => {
            return (<span key={index}>{line}<br/></span>)
          })
        }
        </p>

      </div>
    </div>
  );
}

export default InfoImage;